import React, { useMemo } from "react";
import { MapContainer, Marker, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";
import L from "leaflet";
import { useWindowSize } from "react-use";

interface SurveyLocation {
    lat: number;
    long: number;
}

interface SurveyLocationMapProps {
    locations: SurveyLocation[];
    height?: number | string;
}

const SetBounds = ({ bounds }: { bounds: L.LatLngBounds }) => {
    const map = useMap();
    map.fitBounds(bounds);
    return null;
};

export const SurveyLocationMap: React.FC<SurveyLocationMapProps> = ({
    locations,
    height = 400,
}) => {
    const { width } = useWindowSize();
    const isMobile = width <= 766;

    const validLocations = useMemo(
        () =>
            locations.filter(
                (loc) => loc && typeof loc.lat === "number" && typeof loc.long === "number"
            ),
        [locations]
    );

    const bounds = useMemo(() => {
        if (validLocations.length === 0) return null;

        const latlngs = validLocations.map(
            (loc) => [loc.lat, loc.long] as [number, number]
        );
        return L.latLngBounds(latlngs);
    }, [validLocations]);

    if (validLocations.length === 0) {
        return (
            <div className="flex items-center justify-center h-full text-slate-500">
                No valid locations to display
            </div>
        );
    }

    const center = bounds
        ? bounds.getCenter()
        : L.latLng(validLocations[0].lat, validLocations[0].long);

    return (
        <div style={{ height, width: "100%" }}>
            <MapContainer
                center={[center.lat, center.lng]}
                zoom={isMobile ? 10 : 12}
                scrollWheelZoom={false}
                style={{ height: "100%", width: "100%" }}
            >
                <ReactLeafletGoogleLayer
                    apiKey="AIzaSyCuZfb3JFcDYrKECKU91FKqjK764nvsFGI"
                    type="roadmap"
                />

                {validLocations.map((location, index) => {
                    const orderNumber = index + 1;
                    const customIcon = new L.DivIcon({
                        className: "survey-order-marker",
                        html: `
                            <div style="
                                background-color: #EF4444;
                                color: white;
                                border-radius: 50%;
                                width: 28px;
                                height: 28px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-weight: bold;
                                font-size: 12px;
                                border: 2px solid white;
                                box-shadow: 0 2px 4px rgba(0,0,0,0.3);
                            ">${orderNumber}</div>
                        `,
                        iconSize: [28, 28],
                        iconAnchor: [14, 14],
                    });

                    return (
                        <Marker
                            key={`survey-${index}`}
                            position={[location.lat, location.long]}
                            icon={customIcon}
                        />
                    );
                })}

                {bounds && <SetBounds bounds={bounds} />}
            </MapContainer>
        </div>
    );
};

